import { forwardRef } from 'react'
import { MenuButtonProps, MenuButton as HeadlessMenuButton } from '@headlessui/react'

export const Button = forwardRef<HTMLButtonElement, MenuButtonProps<any>>(({ ...props }: MenuButtonProps<any>, ref) => {
    return <HeadlessMenuButton ref={ref} {...props} />
})
